import { sendPost } from 'helpers/axios';

export const apiTakeStart = (params) => sendPost('/api/take-a-test/start', params);
export const apiSaveTakeTest = (params) => sendPost('/api/take-a-test/finish', params);
